import dayjs from 'dayjs';

import { MIN_DATE_TIME_STRING } from '@totem/components/ticketing/ticketing';

export const ParseDate = (date: number): dayjs.Dayjs | null => {
  if (!date) {
    return null;
  }

  return dayjs(date);
};

export const ParseStringDate = (strDate: string): dayjs.Dayjs | null => {
  if (strDate === MIN_DATE_TIME_STRING) {
    return null;
  }
  const date = new Date(strDate);
  if (!date) {
    return null;
  }
  if (date.getFullYear() < 1900) {
    return null;
  }

  return dayjs(date);
};

export const DateStringToLocal = (dateStringIn: string) => {
  if (dateStringIn !== null) {
    if (dateStringIn !== MIN_DATE_TIME_STRING) {
      if (!isNaN(Date.parse(dateStringIn))) {
        return new Date(dateStringIn).toLocaleString();
      }
    }
  }
  return '-';
};

export const DateStringToLocalDate = (dateStringIn: string) => {
  if (dateStringIn !== null) {
    if (dateStringIn !== MIN_DATE_TIME_STRING) {
      if (!isNaN(Date.parse(dateStringIn))) {
        const dateVal = new Date(dateStringIn);

        if (dateVal.getFullYear() > 1900) {
          return dateVal.toLocaleDateString();
        }
      }
    }
  }
  return '-';
};

// For calendar dates stored as UTC midnight (e.g. NetSuite service periods).
// Formats in UTC so the day doesn't shift back in timezones west of UTC.
export const DateStringToUTCDate = (dateStringIn: string) => {
  if (dateStringIn !== null) {
    if (dateStringIn !== MIN_DATE_TIME_STRING) {
      if (!isNaN(Date.parse(dateStringIn))) {
        const dateVal = new Date(dateStringIn);

        if (dateVal.getUTCFullYear() > 1900) {
          return dateVal.toLocaleDateString(undefined, { timeZone: 'UTC' });
        }
      }
    }
  }
  return '-';
};

export const DateStringToDate = (dateStringIn: string): Date | null => {
  if (dateStringIn !== null) {
    if (dateStringIn !== MIN_DATE_TIME_STRING) {
      if (!isNaN(Date.parse(dateStringIn))) {
        return new Date(dateStringIn);
      }
    }
  }
  return null;
};

export const DaysBetween = (date1: Date | null, date2: Date | null) => {
  if (date1 !== null && date2 !== null) {
    const diff = Math.abs(date1.getTime() - date2.getTime());
    const diffDays = Math.ceil(diff / (1000 * 3600 * 24));

    return diffDays;
  }
  return null;
};

export const DaysBetweenToString = (date1: Date | null, date2: Date | null) => {
  if (date1 !== null && date2 !== null) {
    const diff = Math.abs(date1.getTime() - date2.getTime());
    const diffDays = Math.ceil(diff / (1000 * 3600 * 24));

    return diffDays.toString(10);
  }
  return '-';
};
